<template>
  <div class="wrapper">
    <div v-if="_type === 'text' || _type === 'password' || _type === 'email' || _type === 'number' ">
      <table width="100%">
        <tr>
          <td>
            <label
              :class="[required ? 'required labelText' : 'labelText' ]"
            >
              {{ label }}
            </label>
          </td>
        </tr>
        <tr>
          <td>
            <small class="help-text text-start mb-1">{{ helpText }}</small>
          </td>
        </tr>
        <tr>
          <td>
            <input
              class="form-control"
              v-model="value"
              :type="_type"
              :placeholder="placeholder"
              :disabled="disable"
              :maxlength="maxlength"
              :pattern="regex"
              @input="handleInput"
              @change="handleInputChange"
            >
            <div
              v-if="iconRight"
              class="iconLeft iconclick"
            >
              <div
                class="iconInput"
                @click="showPasswordAction"
              >
                <i v-if="!showPassword" class="bi bi-eye"></i>
                <i v-if="showPassword" class="bi bi-eye-slash"></i>
              </div>
            </div>
            <div
              v-if="iconClear && value"
              class="iconLeft iconclick"
            >
              <div
                class="iconInput"
                @click="clearInput"
              >
                <i class="bi bi-x-circle"></i>
              </div>
            </div>
          </td>
        </tr>
        <tr
          v-show="showError"
        >
          <td>
            <small
              class="float-left text-left invalid-custom-feedback"
            >{{ showError ? errorMsg: '' }}&nbsp;</small>
          </td>
        </tr>
      </table>
    </div>

    <div
      v-else-if="_type === 'radio'"
      class="d-flex flex-column my-2"
    > 
      <table width="100%">
        <tr>
          <td>
            <label
              :class="[required ? 'required labelText' : 'labelText' ]"
            >
              {{ label }}
            </label>
          </td>
        </tr>
        <tr>
          <td class="d-flex flex-column">
            <label
              v-for="(item, key) of items"
              :key="key"
              :class="[required ? 'required radio labelText' : 'radio labelText']"
            >
              {{ item.label }}
              <input
                v-model="checked"
                type="radio"
                :value="item.value"
                :disabled="disable"
                @input="handleInput"
              >
              <span class="radio-checkmark" />
            </label>
          </td>
        </tr>
      </table>
    </div>

    <div v-else-if="_type === 'checkbox' && items.length > 0">
      <table width="100%">
        <tr>
          <td>
            <label
              :class="[required ? 'required labelText' : 'labelText' ]"
            >
              {{ label }}
            </label>
          </td>
        </tr>
        <tr>
          <td>
            <small class="help-text text-start mb-1">{{ helpText }}</small>
          </td>
        </tr>
        <tr>
          <td>
            <div class="btn-group" role="group">
                <ca-smtt-checkbox
                  v-for="(item, index) in items" :key="index"
                  :option="item"
                />
            </div>
          </td>
        </tr>
        <tr
          v-show="showError"
        >
          <td>
            <small
              class="float-left text-left invalid-custom-feedback"
            >{{ showError ? errorMsg: '' }}&nbsp;</small>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import caSmttCheckbox from './ca-smtt-checkbox.vue';
export default {
  components: { caSmttCheckbox },
  data() {
    return {
      showPassword: false,
      showError: false,
      checked: null,
      value: null
    }
  },
  props: {
    type: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    regex: {
      type: String,
      default: null
    },
    maxlength: {
      type: Number,
      default: null
    },
    disable: {
      type: Boolean,
      default: false
    },
    helpText: {
      type: String,
      default: null
    },
    errorMsg: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    initialValue: {
      type: String,
      default: null
    },
    iconRight: {
      type: Boolean,
      default: false
    },
    iconClear: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  unmounted() {
    this.$emit('unMounted', this.value)
  },
  mounted() {
    this.value = this.initialValue
  },
  watch: {
    initialValue(val) {
      this.value = val
    }
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event)
    },
    handleInputChange(event) {
      this.$emit('change', event)
    },
    showPasswordAction() {
      this.showPassword = !this.showPassword;
    },
    clearInput() {
      this.value = ''
      this.$emit('clearInput', this.value)
    }
  },
  computed: {
    _type() {
      return this.showPassword ? 'text' : this.type;
    }
  }
}
</script>
<style scoped>

.required::after {
  color: #6040b9;
  content: ' *';
  font-size: 16px;
}

.wrapper {
  width: 100%;
}


.labelText {
  margin: 0;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: grey;
  float: left;
  border-radius: 4px;
}

/*################## text | password | email | number ################*/

.form-control.padd-r {
  padding-left: 20%;
}

.form-control {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: grey;
  box-shadow: inset 0 0 0 1px grey !important;
  background-color: white;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  min-height: 40px !important;
}
.form-control:focus {
  box-shadow: 0 0 0 2px blue, inset 0 0 0 1px grey !important;
  background-color: white;
}
.form-control:disabled {
  border-color: grey;
}
.form-control.is-invalid {
  border-color: #8f1e1e;
}

.help-text {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.5px;
  color: grey;
}

.iconInput {
  vertical-align: middle;
  float: left;
  margin-left: -1px;
  margin-top: -33px;
  position: relative;
  margin-bottom: -10px;
  z-index: 2;
  margin-right: 1rem;
  display: initial;
}

.iconLeft {
  display: flex;
  width: 100%;
  flex-direction: row-reverse;
  padding-left: 10px;
}

.iconClick{
  cursor: pointer;
}
/*##################radio################*/
.radio {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.radio-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: white;
  border-radius: 50%;
  border: 2px solid black;
}

/* On mouse-over, add a grey background color */
.radio:hover input ~ .radio-checkmark {
  background-color: transparent;
}

/* When the radio button is checked, add a blue background */
.radio input:checked ~ .radio-checkmark {
  background-color: transparent;
  border: 2px solid #522eb3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.radio-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.radio input:checked ~ .radio-checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.radio .radio-checkmark:after {
  top: 3px;
  left: 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #522eb3;
}

.radio input:disabled ~ span {
  background-color: grey !important;
}

/*####################checkbox################*/
/* The container */
.checkbox {
  display: block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkbox-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: white;
  border: 2px solid black;
}

/* On mouse-over, add a grey background color */
.checkbox:hover input ~ .checkbox-checkmark {
  background-color: transparent;
}

/* When the checkbox is checked, add a blue background */
.checkbox input:checked ~ .checkbox-checkmark {
  background-color: transparent;
  border: 2px solid #522eb3;
  background-color: #522eb3;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkbox-checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox input:checked ~ .checkbox-checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox .checkbox-checkmark:after {
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

/* Remove number input arrows */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  appearance: auto;
  -moz-appearance: textfield;
}
</style>